<template>
  <div class="specs-wrap">
    <NavAnchor
      :product-name="$t('common.productName.o1')"
      :spec-url="'/product/aerial-mapper-specs'"
      :product-url="'/product/aerial-mapper'"
    />
    <div class="content d-f fd-r jc-sb c-fff">
      <h1 class="fs-48 in-h5">Specifications</h1>
      <div class="right-img">
        <img v-lazy="require('@/assets/images/aerialmapper/specs.png')" width="100%" height="100%" alt="specs" />
      </div>
      <div class="left-text">
        <h1 class="fs-48 in-pc">Specifications</h1>
        <h3 class="fs-24 fw-500">Sensor System</h3>
        <table class="w-100p">
          <tbody>
            <tr>
              <td>Nadir RGB Camera</td>
              <td>1*150MP industrial camera</td>
            </tr>
            <tr>
              <td>Oblique RGB Camera</td>
              <td>4*150MP industrial camera</td>
            </tr>
            <tr>
              <td>IMU</td>
              <td>Applanix IMU-46</td>
            </tr>
            <tr>
              <td>Maximum frame rate</td>
              <td>0.5 sec (2 fps)</td>
            </tr>
            <tr>
              <td>Nadir-Oblique focus rate</td>
              <td>1:1.8</td>
            </tr>
            <tr>
              <td>Sample flying height</td>
              <td>665 m AGL@5 cm GSD</td>
            </tr>
          </tbody>
        </table>
        <h3 class="fs-24 fw-500">Camera system</h3>
        <table class="w-100p">
          <tbody>
            <tr>
              <td>Nadir RGB lenses</td>
              <td>50 mm focal length, 56.21° FOV across track, 43.65° FOV along track</td>
            </tr>
            <tr>
              <td>Oblique RGB lenses</td>
              <td>90 mm focal length, 33.05° FOV across track, 25.09° FOV along track</td>
            </tr>
            <tr>
              <td>Image size</td>
              <td>14204 x 10652 pixels</td>
            </tr>
            <tr>
              <td>Pixel size</td>
              <td>3.76 μm, back-illuminated CMOS</td>
            </tr>
            <tr>
              <td>Dynamic range</td>
              <td>83 dB</td>
            </tr>
            <tr>
              <td>ADC</td>
              <td>14-bit</td>
            </tr>
            <tr>
              <td>Data channel</td>
              <td>14-bit dedicated compression</td>
            </tr>
            <tr>
              <td>Spectral range</td>
              <td>R (580-660 nm) G (480-590 nm) B (420-510 nm)</td>
            </tr>
            <tr>
              <td>Shutter</td>
              <td>Mechanical central shutter</td>
            </tr>
            <tr>
              <td></td>
              <td>Max speed: Nadir 1/2500 sec, Oblique 1/2000 sec</td>
            </tr>
            <tr>
              <td></td>
              <td>Exchangeable,Up to 500,000 cycle</td>
            </tr>
            <tr>
              <td>Aperture</td>
              <td>Automatically controlled</td>
            </tr>
            <tr>
              <td>Lens mount</td>
              <td>Mechanical bayonet connection</td>
            </tr>
          </tbody>
        </table>
        <h3 class="fs-24 fw-500">Controller</h3>
        <table class="w-100p">
          <tbody>
            <tr>
              <td>Processor</td>
              <td>64-bit WIN 10, 32 GB RAM, 120 GB SSD, USB 3.0, SATA 3.0</td>
            </tr>
            <tr>
              <td>GNSS</td>
              <td>Integrated with Controller, Trimble BD992, 50 Hz update rate</td>
            </tr>
            <tr>
              <td>Storage</td>
              <td>5*2TB SSD</td>
            </tr>
            <tr>
              <td>Storage capability</td>
              <td>3h data record</td>
            </tr>
          </tbody>
        </table>
        <h3 class="fs-24 fw-500">Electrical</h3>
        <table class="w-100p">
          <tbody>
            <tr>
              <td>Average power</td>
              <td>440 W/28 VDC</td>
            </tr>
            <tr>
              <td>Peak power</td>
              <td>570 W/28 VDC</td>
            </tr>
            <tr>
              <td>Power fuse</td>
              <td>40 A recommended</td>
            </tr>
          </tbody>
        </table>
        <h3 class="fs-24 fw-500">Appearance Parameter</h3>
        <table class="w-100p">
          <tbody>
            <tr>
              <td>Weight (without lifter)</td>
              <td>48 kg</td>
            </tr>
            <tr>
              <td>Weight (with lifter)</td>
              <td>66 kg</td>
            </tr>
            <tr>
              <td>Height/Diameter</td>
              <td>663 mm/400 mm</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import NavAnchor from '@/components/NavAnchor'

  export default {
    components: {
      NavAnchor
    },
    data() {
      return {}
    },
    head() {
      return {
        title: 'Trion O1 AerialMapper– FJDynamics',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Trion O1 AerialMappe, FJDynamics, FJD '
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'A large-format aerial solution with both nadir camera and oblique camera，150MP each，which is widely used in wide-area mapping and 3D city model'
          }
        ]
      }
    },
    created() {},
    mounted() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .specs-wrap {
    background: #120f14;
  }
  /* pc端样式 */
  @media screen and (min-width: 768px) {
    .fs-48 {
      font-size: 0.48rem;
    }
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-28 {
      font-size: 0.28rem;
    }
    .fs-24 {
      font-size: 0.24rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }

    main {
      padding-top: 0.76rem;
    }

    .content {
      padding: 1.2rem 0.8rem 2.3rem 2.85rem;
    }
    .content .left-text {
      width: 8rem;
    }
    .content h3 {
      margin-top: 0.65rem;
      margin-bottom: 0.24rem;
      padding-bottom: 0.16rem;
      border-bottom: 1px solid #999;
    }
    .content table td {
      padding: 0.08rem 0;
      vertical-align: top;
    }
    .content table td:nth-of-type(2n) {
      text-align: right;
    }
    .content .right-img {
      width: 6.63rem;
      height: 10.73rem;
      margin-top: 6rem;
    }
  }
</style>
